import React, { useState } from "react";
import { Spin } from "antd";
import {
  useCreateAWSRegisterationMutation,
  useGetAWSRegistraionDetailsQuery,
} from "../redux/slices/register/registerApiSlice";
import RegistrationTheme from "../theme/RegistrationTheme";
import NotFound from "../not-found";
import { Section } from "../StyledComponent";

function AWSRegistartion({
  sellerId,
  productCode,
  customerIdentifier,
  licenseArn,
}: {
  sellerId: string;
  productCode: string;
  customerIdentifier: string;
  licenseArn: string;
}) {
  const [successMessage, setSuccessMessage] = useState(false);

  const { data, isLoading, isError } = useGetAWSRegistraionDetailsQuery(
    {
      sellerId,
      productCode,
      customerIdentifier,
    },
    {
      skip: !(sellerId && productCode && customerIdentifier),
    },
  );

  const [createRegisterListMutation, { isLoading: loading }] = useCreateAWSRegisterationMutation();

  const onFinish = async (values: any) => {
    const registrationData = (data?.registration_page_fields || [])?.map((item: any) => ({
      registration_page_field: item?.id,
      value: values?.[item?.title] || "",
    }));

    const result: any = await createRegisterListMutation({
      data: registrationData,
      sellerId,
      productCode,
      customerIdentifier,
      licenseArn,
    });
    if (result?.error) return result.error;
    setSuccessMessage(true);
    return undefined;
  };

  if (sellerId && productCode && customerIdentifier && !isError) {
    return (
      <Spin spinning={isLoading}>
        <Section style={{ height: "100vh" }}>
          {!isLoading && (
            <RegistrationTheme
              registrationData={data}
              successMessage={successMessage}
              onFinish={onFinish}
              isLoading={loading}
            />
          )}
        </Section>
      </Spin>
    );
  }

  return <NotFound />;
}

export default AWSRegistartion;
